import React from 'react'
import ImageModal from '@/apps/ImageModal'
import { useModal } from '@/hooks'

const Image = (): React.ReactElement => {
  const { modalProps } = useModal()

  const { image } = modalProps
  return <ImageModal src={image} />
}

export default Image
